import { Selector } from '@ngxs/store';

import { CourtEventNoteSaveStateModel } from './court-event-note-save.state.model';
import { CourtEventNoteSaveState } from './court-event-note-save.state';

export class CourtEventNoteSaveSelectors {
    @Selector([CourtEventNoteSaveState])
    static isFormValid(state: CourtEventNoteSaveStateModel): boolean {
        return state.form.status === 'VALID';
    }

    @Selector([CourtEventNoteSaveState])
    static isFormLoading(state: CourtEventNoteSaveStateModel): boolean {
        return state.form.isLoading;
    }
}
